$(function() { 
    $("#tabs ul li").on("click", function(){
      var href = $(this).find('a').attr("href");
      if(href == "#tabs-1" || href == "#tabs-2"){
        $("#tabs "+href).find("ul.tabs-bl .tabs-bl-li:eq(0)").trigger("click");
      }else if(href == "#tabs-3"){
        $("#tabs "+href).find(".row-service .left-section .service-tab:eq(0)").trigger("click");
      }
    });

    $("ul.tabs-bl .tabs-bl-li").on("click", function(){
      var data_tab = $(this).find("button").attr("data-tab");
      $("ul.tabs-bl .tabs-bl-li").removeClass("tabs-bl-li-active");
      $(this).addClass("tabs-bl-li-active");
      $(this).parents(".container").find(".home-blog-posts .operations__content").removeClass("operations__content--active");
      $(this).parents(".container").find(".home-blog-posts .operations__content.operations__content--"+data_tab).addClass("operations__content--active");
      var element = $(this).parents(".container").find(".home-blog-posts .operations__content.operations__content--"+data_tab+" [data-blogs-slider]");
      if(element.length){
        element.slick("unslick");
        setTimeout(function(){
          element.not('.slick-initialized').slick({
             infinite: false,
             slidesToShow: 4,
             slidesToScroll: 1,
             arrows:false
           });
        },100);
      }
    });

    $(".row-service .left-section .service-tab").on("click", function(){
      var data_tab = $(this).attr("data-tab");
      $(".row-service .left-section .service_name").removeClass('active');
      $(this).find(".service_name").addClass("active");
      $(".row-service .right-section .tabs-content").hide();
      $(".row-service .right-section .tabs-content[data-tab='"+data_tab+"']").show();

      if($(".row-service .right-section .tabs-content[data-tab='"+data_tab+"'] .service-item").length == 0){
        var url = "https://shakehands.feyntech.in/api/"+data_tab;
        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          success: function (data) {
            if(data.length > 0){
              var html = '';
              $.each(data, function(index, value){
                var name = value.name;
                var qualification = value.qualification;
                var experience = value.experience;
                var verified = value.verified;
                var location = value.location;
                var googleLocation = value.googleLocation;

                html += '<div class="service-item col-md-4 col-12">\
                    <div class="service-box">\
                      <div class="user-list">\
                        <div class="user-image">\
                            <img class="service-image img-fluid float-left" src="http://3.bp.blogspot.com/-IbEOTNtCMyU/TfCAdHaAxEI/AAAAAAAAA8U/EATib38SSAM/s320/joe-mcelderry.jpg" alt="...">\
                        </div>\
                        <div class="user-name">\
                          <h3 class="service-heading">'+name+'</h3>\
                          <h4 class="qualification">'+qualification+'  |  '+experience+'</h4>\
                  <div class="location-logo">\
                  <img class="location-pad" src="https://cdn.shopify.com/s/files/1/0652/2381/9522/files/verified-service-icon.svg?v=1667817170" >\
                          <h4 class="service-verify">'+(verified ? 'Verified' : '')+'</h4>\
                  </div>\</div>\
                        </div>\
                        <div class="inner-part">\
                          <div class="time-sec">\
                              <div class="">\
                                  <h3 class="service-timming">Timing : </h3>\
                              </div>\
                              <div class="">\
                                  <h3 class="service-tvalue">9:00 am - 12:00 pm</h3>\
                              </div>\
                          </div>\
                          <div class="time-sec">\
                              <div class="">\
                                  <h3 class="service-timming">Contact : </h3>\
                              </div>\
                              <div class="">\
                                  <h3 class="service-tvalue">+91 92039 98263</h3>\
                              </div>\
                          </div>\
                        </div>\
                        <div class="map-info">\
                            <div class="location-logo">\
                                <img class="location-pad" src="https://cdn.shopify.com/s/files/1/0652/2381/9522/files/map-service-icon.svg?v=1667817170" >\
                                <h3 class="service-direction">'+location+'</h3>\
                            </div>\
                            <div class="">\
                                <a href="'+googleLocation+'" target="_blank" class="btn btn-lg btn-direction">Direction</a>\
                            </div>\
                        </div>\
                     </div>\
                  </div>';
              });
              $(".row-service .right-section .tabs-content[data-tab='"+data_tab+"']").html(html);
            }
          }
        });
      }
    });
});

$(document).on("click", ".swatch-element", function(){
  if($(this).hasClass('soldout')){
    $("#notify-me-wrapper").show();
  }else{
    $("#notify-me-wrapper").hide();
  }
});

$(document).on("click", ".product-notify-me", function(){
  var variant_id = $(this).parents('form#add-to-cart-form').find('#product-selectors').val();
  var customer_id = $(this).attr('data-customer_id');
  if(variant_id && customer_id){
    var url = "https://backend.shakehands.co.in/oms/customer/add-notification";

    var settings = {
      "url": url,
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "customerId": "gid://shopify/Customer/"+customer_id,
        "variantId": "gid://shopify/ProductVariant/"+variant_id
      }),
    };

    $.ajax(settings).done(function (response) {
      // console.log(response);
      $('#notify-soldout .modal-body').html('Thank you. We will notify you, when product back in stock');
      $('#notify-soldout').modal();
    });
  }
});


$(document).on("click", "a.wishlist", function(){
  var variant_id = $(this).parents('form#add-to-cart-form').find('#product-selectors').val();
  if(!variant_id){
    variant_id = $(this).parents('.product-bottom').find('select[name="id"].product-form__variants').val();
  }
  if(!variant_id){
    variant_id = $(this).parents('.product-bottom').find('#product-variants input[name="id"]').val();
  }
  var customer_id = $(this).attr('data-customer_id');
  if(variant_id && customer_id){
    var url = "https://backend.shakehands.co.in/oms/customer/add-wishlist";

    var settings = {
      "url": url,
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "customerId": "gid://shopify/Customer/"+customer_id,
        "variantId": "gid://shopify/ProductVariant/"+variant_id
      }),
    };

    $.ajax(settings).done(function (response) {
      // console.log(response);
    });
  }
});

window.onload = function(){
  var href = window.location.href;
  if(href.indexOf('/products') !== -1){
    var variant_id =  $('form#add-to-cart-form').find('#product-selectors').val();
    if(variant_id && customer_id){
      var url = "https://backend.shakehands.co.in/oms/customer/add-product-viewed";
      var settings = {
        "url": url,
        "method": "POST",
        "timeout": 0,
        "headers": {
          "Content-Type": "application/json"
        },
        "data": JSON.stringify({
          "customerId": "gid://shopify/Customer/"+customer_id,
          "variantId": "gid://shopify/ProductVariant/"+variant_id
        }),
      };

      $.ajax(settings).done(function (response) {
        // console.log(response);
      });
    }
  }


}
